import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { Button, Form } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MyDate from "../../../MyComp/UI/form/MyDate";
import MySelect from "../../../MyComp/UI/form/MySelect";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import moment from "moment";
import MyButton from "../../../MyComp/UI/form/MyButton";
import { StepHeader } from "./StepHeader";
import MyPAN from "../../../MyComp/UI/form/MyPAN";
import MyAadhaar from "../../../MyComp/UI/form/MyAadhaar";

import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";
import MyCreateSelect from "../../../MyComp/UI/form/MyCreateSelect";
import { listStoreDDAPI, stepOnePharmacyDetails } from "../../../api/dropdown";
import { createPharmacyStore } from "../../../api/master/indes";
import { BASE_URL_IMG } from "../../../assets/constants";

const StepOnePharmacy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      storeTypeDD: [],
      countryDD: [{ value: "India", label: "India" }],
      country: { value: "India", label: "India" },
      stateDD: [],
      cityDD: [],
      paymentModeDD: [
        {
          value: "card",
          label: "Card",
        },
        {
          value: "cash",
          label: "Cash",
        },
        {
          value: "net_banking",
          label: "Net Banking",
        },
        {
          value: "upi",
          label: "UPI",
        },
      ],
      deliveryRadiusDD: [
        {
          value: "1",
          label: "1 KM",
        },
        {
          value: "2",
          label: "2 KM",
        },
        {
          value: "3",
          label: "3 KM",
        },
        {
          value: "4",
          label: "4 KM",
        },
        {
          value: "5",
          label: "5 KM",
        },
        {
          value: "6",
          label: "6 KM",
        },
        {
          value: "7",
          label: "7 KM",
        },
        {
          value: "8",
          label: "8 KM",
        },
        {
          value: "9",
          label: "9 KM",
        },
        {
          value: "10",
          label: "10 KM",
        },
      ],

      store_image: null,
      store_img: null,

      pan_image: null,
      pan_img: null,

      drug_img: null,
      drug_image: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      catalog_image: null,
      catalog_img: null,

      fssai_image: null,
      fssai_img: null,

      cheque_image: null,
      cheque_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const doctorId = location?.state?.doctorId || "";
  const isLoading = watch("isLoading");
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  console.log(location, "location,");
  const onFormSubmit = (data) => {
    console.log(data, "data");

    const formData = new FormData();

    // Text fieldsif()
    if(location.state.pharmacyId != null ){
    formData.append("pharmacyId",location.state.pharmacyId)}
    formData.append("store_name", data.name || "");
    formData.append("storeId", data.store_type?.value || "");
    formData.append("gst_number", data.pharmacy_gst_no || "");
    // formData.append("gst_no", data.pharmacy_gst_no || "");
    formData.append("contactNumber", data.pharmacy_mobile || "");
    formData.append("mobile", data.mobile || "");
    formData.append("license_no", data.pharmacy_license_no || "");

    // Binary image
    const storeImg = data.store_img;

    // if (!(storeImg instanceof File)) {
    //   toast.error("Store image is required");
    //   return;
    // }

    formData.append("store_image", storeImg);

    // API call
    if (mode === "Add" || mode === "Edit") {
      createPharmacyStore(formData).then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          console.log(res.data.data, "resdataaaa");
          navigate("/pharmacy-registration/pharmacy-operational-details", {
            state: { mode: mode, pharmacyId: mode === "Add" ? res.data.data?.pharmacyId : location.state.pharmacyId },
          });
        }
        else if (res?.data?.status === "expired") {
      toast.error(res.data.message);
      logout();
    }
    else {
          toast.error(res?.data?.message || "Operation failed");
        } 
      });
      
    }
  };
  useEffect(() => {
    getStoreType();
  }, []);
  const getStoreType = (body) => {
    listStoreDDAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("storeTypeDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("storeTypeDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const body = { pharmacyId: location.state.pharmacyId };
    if (mode == "Edit") {
      stepOneDetails(body);
    }
  }, []);
  const stepOneDetails = (body) => {
    stepOnePharmacyDetails(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          const data = res.data.data;
          console.log(data, "stepOneDetails");

          // Map API response to form fields
          setValue("name", data.store_name || "");
          setValue("pharmacy_license_no", data.license_number || "");
          setValue("pharmacy_gst_no", data.gst_number || "");
          setValue("mobile", data.mobile || "");
          setValue("pharmacy_mobile", data.contactNumber || "");

          // For store_type, pick first value from store_data
          // Store type (select)
          if (data.store_data) {
            setValue("store_type", {
              value: data.store_data.value,
              label: data.store_data.label,
            });
          }

          // Store image
          setValue("store_image", data?.store_image ? `${BASE_URL_IMG}${data.store_image}` : "");

          // Stop loading
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title={"Pharmacy Registration | Pharmacy Profile"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Pharmacy Registration"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate("/pharmacy-list");
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={1} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <div className="d-flex gap-5 py-3 mb-3">
                  {" "}
                  <h5>{"Pharmacy Details"}</h5>
                </div>
                <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Store Name"
                    name="name"
                    placeholder="Enter Pharmacy Name"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md={4}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Store Type"}
                    name={"store_type"}
                    placeholder={"Select type"}
                    required
                    options={watch("storeTypeDD")}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="License Number"
                    name="pharmacy_license_no"
                    placeholder="Enter Pharmacy License No"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title=" GST Number"
                    name="pharmacy_gst_no"
                    placeholder="Enter Pharmacy GST No"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Contact Number"}
                    name={"pharmacy_mobile"}
                    placeholder={"Enter pharmacy mobile"}
                    required={mode=="Add"}
                    disabled={mode == "Approval"}
                      readOnly={mode == "Edit"}

                  />
                </Col>
                <Col md="4" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Mobile Number"}
                    name={"mobile"}
                    placeholder={"Enter mobile Number"}
                           required={mode=="Add"}
                    disabled={mode == "Approval"}
                       readOnly={mode == "Edit"}
                  />
                </Col>
                <Col md="4">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="store_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={" Store Image"}
                    errors={errors}
                    register={register}
                    image={"store_img"}
                    image_url={"store_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required={mode =="Add"}
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
              </Row>

              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default StepOnePharmacy;
